/*
 * Add a play/pause button to html5 video elements.
Test
 */
window.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const videoPlayer = () => {
    // Get current page language
    const lang = document.documentElement.lang;
    let translations;
    if (lang === 'da') {
      translations = {
        'pause': 'Stop afspilning (brug Enter tast)',
        'play': 'Afspil (brug Enter tast)'
      }
    } else {
      translations = {
        'pause': 'Pause (use Enter key)',
        'play': 'Play (use Enter bar)'
      }
    }

    // Check if there is a html video element
    const videos = document.querySelectorAll('.videocontainer');
    if (!videos) {
      return;
    }

    // Create play/pause button - or add in html
    //const button = '<button aria-label="' + translations.pause + '" class="btn play-pause-button" type="button"></button>';

    class Video {
      constructor(video) {
        this.videoContainer = video;
        //this.videoContainer.insertAdjacentHTML('beforeend', button);
        this.video = this.videoContainer.querySelector('video');
        this.btn = this.videoContainer.querySelector('.play-pause-button');
        if (!this.btn) {
          return;
        }
        this.prefersReducedMotion();
        this.addEventListeners();
      }

      addEventListeners() {
        this.btn.addEventListener('click', () => {
          this.togglePlayPause();
        });

        // Pause/play video by hitting the "Esc" key
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.togglePlayPause();
          }
        });
      }

      togglePlayPause() {
        if (this.video.paused || this.video.ended) {
          this.playVideo();
        } else {
          this.pauseVideo();
        }
      }

      playVideo() {
        this.video.play();
        this.btn.classList.remove('paused');
        this.btn.setAttribute('aria-label', translations.pause);
        this.btn.setAttribute('data-category-content-name', translations.pause);
      }

      pauseVideo() {
        this.video.pause();
        this.btn.classList.add('paused');
        this.btn.setAttribute('aria-label', translations.play);
        this.btn.setAttribute('data-category-content-name', translations.play);
      }

      prefersReducedMotion() {
        if (this.video.autoplay === false || matchMedia('(prefers-reduced-motion)').matches) {
          this.video.removeAttribute('autoplay');
          this.pauseVideo();
          this.video.currentTime = 0;
        }
      }
    }

    Array.from(videos).forEach((video) => {
      const videoEl = new Video(video);
    });

  }
  videoPlayer();
});